/**
 * GamePage — Routes to the correct sub-view based on the mode query param.
 * mode=lobby   → RoomPage (waiting room)
 * mode=single  → SinglePlayerGameView (engine in browser)
 * mode=playing → MultiplayerGameView (socket-driven)
 * default      → MultiplayerGameView (fallback for active games)
 */

import { useSearchParams, useParams } from 'react-router-dom';
import { RoomPage } from './RoomPage';
import { SinglePlayerGameView } from '../components/SinglePlayerGameView';
import { MultiplayerGameView } from '../components/MultiplayerGameView';

export function GamePage() {
  const [searchParams] = useSearchParams();
  const { roomCode } = useParams<{ roomCode: string }>();
  const mode = searchParams.get('mode');

  if (mode === 'lobby') {
    return <RoomPage />;
  }

  if (mode === 'single') {
    const ai = (searchParams.get('ai') ?? 'medium') as 'easy' | 'medium' | 'hard';
    return <SinglePlayerGameView difficulty={ai} roomCode={roomCode!} />;
  }

  // mode=playing or default — multiplayer game board
  return <MultiplayerGameView roomCode={roomCode!} />;
}
